import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './RiskPotentialStyle.scss';
import { withRouter } from "react-router-dom";
import { Config } from '../../../../../shared/config';

class RiskPotential extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    /**
     * Render elements
     */
    render() {
        let lookerReadmittanceUrl = '';
        let lookerAdherenceUrl = '';
        let lookerRiskType = '';
        let analyticsReportType = '';

        //Set analytics report type
        if (this.props.match.params && this.props.match.params.reportKey) {
            analyticsReportType = Config.analytics.filter(item => item.reportKey === this.props.match.params.reportKey)[0];
        }

        //Set analytics risk type
        if (this.props.getRiskType && (this.props.getRiskType.setType && this.props.getRiskType.setType.payload)) {
            lookerRiskType = this.props.getRiskType.setType.payload.riskTypeId;
        }

        //Set looker adherence embedded url
        if (this.props.getLookerUrl && (this.props.getLookerUrl.setUrl && this.props.getLookerUrl.setUrl.payload)) {
            if (this.props.getLookerUrl.setUrl.payload.adherence) {
                lookerAdherenceUrl = this.props.getLookerUrl.setUrl.payload.adherence;
            }
        }

        //Set looker readmittance embedded url
        if (this.props.getLookerUrl && (this.props.getLookerUrl.setUrl && this.props.getLookerUrl.setUrl.payload)) {
            if (this.props.getLookerUrl.setUrl.payload.readmittance) {
                lookerReadmittanceUrl = this.props.getLookerUrl.setUrl.payload.readmittance;
            }
        }

        return (
            <div className="dummy ">
                <div className="section-head">
                    {analyticsReportType && analyticsReportType.reportName ?
                        <p>{analyticsReportType.reportName}</p>
                    : null }
                </div>
                <div className="report-looker-graph">

                    <Row>
                        <Col md={12}>
                            <div className="iframe-graph">
                                <iframe className={(lookerRiskType && lookerRiskType === 1) ? 'd-block' : 'd-none'} id="lookerReadmittance" title="looker-graph" scrolling="no" src={lookerReadmittanceUrl}
                                />
                                <iframe className={(lookerRiskType && lookerRiskType === 2) ? 'd-block' : 'd-none'} id="lookerAdherancce" title="looker-graph" scrolling="no" src={lookerAdherenceUrl}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
            </div >

        );
    }
}


/**
 * Mapping redux state into props 
 */
const MapStateToProps = (state) => {
    return {
        getLookerUrl: state.getAnalyticsLookerUrl,
        getRiskType: state.getRiskType,
    };
}

RiskPotential.propTypes = {
    getLookerUrl: PropTypes.object,
    getRiskType: PropTypes.object,
    match: PropTypes.object.isRequired,
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
    }),
};

export default connect(MapStateToProps, null)(withRouter(RiskPotential));